import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "service-region-configuration-for-pdf-services-apis"
    }}>{`Service Region Configuration for PDF Services APIs`}</h1>
    <h2 {...{
      "id": "default-configuration"
    }}>{`Default Configuration`}</h2>
    <p>{`Adobe PDF Services APIs use `}<inlineCode parentName="p">{`United States`}</inlineCode>{` as a default region to process all the documents.
Once you purchase PDF Services API, its APIs can be configured to process the documents in a specified region that is listed below. `}</p>
    <h2 {...{
      "id": "service-region-configuration"
    }}>{`Service Region Configuration`}</h2>
    <p>{`Currently, PDF Services APIs have support for the following regions :`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Region Code`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Hostname`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ue1`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`United States (default)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://pdf-services-ue1.adobe.io"
            }}>{`https://pdf-services-ue1.adobe.io`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ew1`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Europe`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://pdf-services-ew1.adobe.io"
            }}>{`https://pdf-services-ew1.adobe.io`}</a></td>
        </tr>
      </tbody>
    </table>
    <br />
    <p>{`For invoking region specific PDF Services API endpoints, hostnames needs to be changed to the following pattern : `}<inlineCode parentName="p">{`https://pdf-services-{regionCode}.adobe.io`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "assets-api"
    }}>{`Assets API`}</h3>
    <CodeBlock slots="heading, code" repeat="1" languages="Rest API" mdxType="CodeBlock" />
    <h4 {...{
      "id": "rest-api"
    }}>{`Rest API`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`curl --location --request POST 'https://pdf-services-ew1.adobe.io/assets' \\
--header 'X-API-Key: {{Placeholder for client_id}}' \\
--header 'Authorization: Bearer {{Placeholder for token}}' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "mediaType": "{{Placeholder for mediaType}}"
}'
`}</code></pre>
    <h3 {...{
      "id": "create-job-api"
    }}>{`Create Job API`}</h3>
    <CodeBlock slots="heading, code" repeat="1" languages="Rest API" mdxType="CodeBlock" />
    <h4 {...{
      "id": "rest-api-1"
    }}>{`Rest API`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`
curl --location --request POST 'https://pdf-services-ew1.adobe.io/operation/{Placeholder for operation name}' \\
--header 'x-api-key: {{Placeholder for client_id}}' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer {{Placeholder for token}}' \\
--data-raw '{
    "assetID": "{{Placeholder for asset ID}}"
}'

`}</code></pre>
    <h3 {...{
      "id": "poll-job-api"
    }}>{`Poll Job API`}</h3>
    <CodeBlock slots="heading, code" repeat="1" languages="Rest API" mdxType="CodeBlock" />
    <h4 {...{
      "id": "rest-api-2"
    }}>{`Rest API`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`
curl --location --request GET 'https://pdf-services-ew1.adobe.io/operation/{Placeholder for operation name}' \\
--header 'x-api-key: {{Placeholder for client_id}}' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer {{Placeholder for token}}'
'
`}</code></pre>
    <p>{`For a step-by-step guide to use Adobe PDF services APIs, please `}<a parentName="p" {...{
        "href": "./api-usage.md"
      }}>{`click here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      